import { render, staticRenderFns } from "./AddDips.vue?vue&type=template&id=0c24bdf0&scoped=true"
import script from "./AddDips.vue?vue&type=script&lang=js"
export * from "./AddDips.vue?vue&type=script&lang=js"
import style0 from "./AddDips.vue?vue&type=style&index=0&id=0c24bdf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24bdf0",
  null
  
)

export default component.exports